<template>
  <v-app color="primary" class="its-map-app" :class="[
    {'contrast-active': !!getContrastActive}, 
    { 'mobile-app': mobileView()},
    getFontSizeClass
    ]">
    <TopBar />
    <AppMainLayout>
      <template v-slot:left-sidebar>
        <!-- <SidebarContent/> -->
      </template>
      <template v-slot:right-sidebar>
        <!-- <InfoSidebar/> -->
      </template>
      <template v-slot:main>
        <MapWindow/>
      </template>
    </AppMainLayout>
    <FooterBar />
    <div
      id="overlay-main"
      :class="{
      'overlay': true,
      'overlay--show': showModal
    }">
    </div>
    <EventsListModal v-if="showEventListModal" :show="showEventListModal"/>
    <InfoModal v-if="showInfoModal" :show="showInfoModal"/>
    <StartModal v-if="showStartModal && !mobileView() && !isPopupDisabled()" :show="showStartModal"/>
    <CookiesButton />
    <notifications
      group="app-notif"
      position="top left"
      :ignoreDuplicates="true"
    />
  </v-app>
</template>

<script lang="ts">
// import { computed, defineComponent, onBeforeMount, onMounted, Ref, watch } from "vue";
// // import AppMain from '@/components/AppMain.vue';
// import WcagToolbar from '@/components/WcagToolbar.vue';
// import store from '@/store/index';
import { computed, defineComponent, Ref, watch, onBeforeMount, SetupContext, reactive } from 'vue';
import MapWindow      from '@/components/map/MapWindow.vue';
import TopBar         from '@/components/structural/TopBar.vue';
import FooterBar         from '@/components/structural/FooterBar.vue';
import SidebarContent from '@/components/structural/SidebarContent.vue';
import AppMainLayout  from '@/components/structural/AppMainLayout.vue';
// import InfoSidebar    from '@/components/structural/InfoSidebar.vue';
import Modal          from '@/components/modals/Modal.vue';
import EventsListModal          from '@/components/modals/EventsListModal.vue';
import store          from '@/store/index';
import { useLocale, useTheme } from "vuetify";
import InfoModal from './components/modals/InfoModal.vue';
import CookiesButton from './components/structural/CookiesButton.vue';
import StartModal from './components/modals/StartModal.vue';

export default defineComponent({
  name: "App",
  components: {
    MapWindow,
    TopBar,
    FooterBar,
    SidebarContent,
    AppMainLayout,
    InfoModal,
    Modal,
    EventsListModal,
    CookiesButton,
    StartModal,
  },

  setup(props, context: SetupContext) {
    const theme = useTheme();
    const showModal: Ref<boolean> = computed(() => store.state.modal.display);
    const showEventListModal: Ref<boolean> = computed(() => store.state.otherModals.eventListModal.display);
    const showInfoModal: Ref<boolean> = computed(() => store.state.otherModals.infoModal.display);
    const showStartModal: Ref<boolean> = computed(() => store.state.otherModals.startModal.display);
    const getContrastActive: Ref<boolean> = computed((): boolean => store.getters.getContrastActive);
    const getFontSize: Ref<number> = computed((): number => store.getters.getFlipResizeActive);

    const getFontSizeClass: Ref<string> = computed((): string => {
      let fontClass;

      switch (getFontSize.value) {
        case 1:
          fontClass = 'font-size-low';
          document.documentElement.style.fontSize = '15px';
          break
        case 3:
          fontClass = 'font-size-high';
          document.documentElement.style.fontSize = '17px';
          break
        case 2:
        default:
          fontClass = 'font-size-standard';
          document.documentElement.style.fontSize = '16px';
          break
      }

      return fontClass;
    });

    const mobileView = () => {
      if (window.location.hostname.split('.')[0] === 'mob') {
        return true;
      }
      return false;
    };

    const isPopupDisabled = () => {
      const params = new URLSearchParams(window.location.search);
      const popup = params.get('popup');
      if (popup === 'off') {
        return true;
      }
      return false;
    };

    // const googleTranslateElementInit = () => {
    //   // @ts-ignore
    //   window.google.translate.TranslateElement(
    //     { pageLanguage: "pl" },
    //     "google_translate_element"
    //   );
    // };

    onBeforeMount(() => {
      // googleTranslateElementInit();
      // const redrawService: RedrawService = new RedrawService(new MapService(store.state.leafletMapInstance));
      // get url params <- to do later move to out service
      const params = reactive({
        contrast: 'false',
        fontSize: '2',
        lang: 'pl',
      });
      // const queryParams = new URLSearchParams(window.location.search);
      // params.contrast = queryParams.get('contrast') || 'false';
      // params.fontSize = queryParams.get('fontSize') || '2';
      // params.lang = queryParams.get('lang') || 'pl';
      if (params.contrast == 'true' || getContrastActive.value === true) {
        // store.commit('flipContrastActive');
        theme.global.name.value = 'dark';
        document.documentElement.className = 'dark-theme';
      } else {
        document.documentElement.className = 'light-theme';
        theme.global.name.value = 'light';
      }
    });

    watch(() => getContrastActive.value, () => {
      if (getContrastActive.value === true ) {
        document.documentElement.className = 'dark-theme';
      } else {
        document.documentElement.className = 'light-theme';
      }
    });

    return {
      showModal,
      showEventListModal,
      showInfoModal,
      showStartModal,
      getContrastActive,
      getFontSize,
      getFontSizeClass,
      mobileView,
      isPopupDisabled,
    };
  },
});
</script>
<style lang="scss">


.test {
  font-size: rem(30px);
  color: $static_red_light;
}

.its-map-app {

  .leaflet-layer{
    // filter: brightness(0.8) contrast(1.3) saturate(0.8);
  }
  // dark style for map
  .dark-theme & {
    .leaflet-layer{
      filter: invert(100%) hue-rotate(180deg) brightness(95%) contrast(100%) grayscale(1); 
    }
  }

  .vue-notification-group {
    margin-top: rem(115px);
    font-family: "Roboto", sans-serif;

    .vue-notification {
      &.info {
        background: #84aaf3;
        border-left-color: #2589f3;
      }
    }
  }

  .overlay {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;

    &.overlay--show {
      pointer-events: all;
    }
  }

  .contrast-switcher {
    position: fixed;
    background: #00004d;
    right: 0;
    top: 48%;
    z-index: 999;
    width: 34px;
    height: 34px;
    border-radius: 10px 0 0 10px;
    outline: none;

    @at-root {
      // .contrast-active .contrast-switcher {
      //   background: white;
      // }
    }

    &__icon {
      color: white;

      &--active {
        color: #00004d;
      }
    }
  }
}
// .main-container {
//   border: 1px solid #1867c0;

//   &.small {
//     font-size: 13px; 
//   }
//   &.big {
//     font-size: 20px; 
//   }
// }

// .-dark-mode {
//   background-color: black;
//   color: yellow;

//   #leaflet-map {
//     filter: invert(100%) hue-rotate(180deg) brightness(95%) contrast(100%) grayscale(0);
//   }
// }
</style>
